import React, { useEffect, useRef, useState } from "react";

import styles from "./IconTooltip.module.scss";

var languageFile = require("../../../../public/languages/Translation");

export const IconTooltip = (props) => {
	const tooltipRef = useRef();
	const [positionX, setPositionX] = useState(props.positionX);
	const [positionY, setPositionY] = useState(props.positionY);
	useEffect(() => {
		const edges = {
			right:
				Math.abs(props.positionX - props.canvasWidth) <
				tooltipRef.current.offsetWidth,
			bottom:
				Math.abs(props.positionY - props.canvasHeight) <
				tooltipRef.current.offsetHeight,
		};

		setPositionX(
			edges.right
				? props.positionX - tooltipRef.current.offsetWidth
				: props.positionX,
		);
		setPositionY(
			edges.bottom
				? props.positionY - tooltipRef.current.offsetHeight
				: props.positionY,
		);
	}, [tooltipRef.current, props]);
	return (
		<div
			className={styles.iconTooltip}
			ref={tooltipRef}
			onMouseEnter={props.onMouseEnter}
			onMouseLeave={props.onMouseLeave}
			style={{
				transform: `translate(${positionX}px, ${positionY}px)`,
			}}>
			{props.data.overlapItems && props.data.overlapItems.length > 1 ? (
				<div className={styles.iconTooltip__overlapList}>
					{props.data.overlapItems.map((overlapItem, index) => (
						<div
							className={styles.iconTooltip__overlapItem}
							key={overlapItem.reviewDocId || index}>
							{overlapItem.storeCode && <p>{overlapItem.storeCode}</p>}
							{overlapItem.locationName && <p>{overlapItem.locationName}</p>}
							{overlapItem.rating && (
								<p>{`${overlapItem.rating} ${languageFile[localStorage.getItem('language')]['22191']}`}</p>
							)}
							{overlapItem.reviewer && (
								<p>{`${languageFile[localStorage.getItem('language')]['30933']}: ${overlapItem.reviewer}${overlapItem.source ? ` (${overlapItem.source})` : ""}`}</p>
							)}
						</div>
					))}
				</div>
			) : (
				<>
					{props.data.storeCode && <p>{props.data.storeCode}</p>}
					{props.data.locationName && <p>{props.data.locationName}</p>}
					{props.data.rating && (
						<p>{`${props.data.rating} ${languageFile[localStorage.getItem('language')]['22191']}`}</p>
					)}
					{props.data.reviewer && (
						<p>{`${languageFile[localStorage.getItem('language')]['30933']}: ${props.data.reviewer}`}</p>
					)}
				</>
			)}
		</div>
	);
};
